import FieldTypeItem from './FieldTypeItem';
import './style/field-type-item.less';

export default FieldTypeItem;
